import { MouseEventHandler, ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';
import BaseHeadline from './BaseHeadline';


export type ContainerCompType = {
    children: ReactNode;
    className?: string;
    onClick?: MouseEventHandler<HTMLDivElement>
};

export function BaseCardContainer({ children, className, onClick }: ContainerCompType) {
    const classes = twMerge('flex flex-col gap-8 rounded-xl border border-base-300/80 bg-base-100', className ?? '')
    return (
        <div
            onClick={onClick}
            className={classes}>
            {children}
        </div>
    );
}

export function BaseCardContent({ children, className }: ContainerCompType) {
    const classes = twMerge('px-6 [&:last-child]:pb-6 ', className ?? '')
    return (
        <div className={classes}>
            {children}
        </div>
    )
}

export function BaseCardHeader({ children, className }: ContainerCompType) {
    const classes = twMerge("flex justify-between items-center gap-1.5 px-6 pt-8 has-data-[slot=card-action]:grid-cols-[1fr_auto] [.border-b]:pb-6", className ?? '')
    return (
        <div className={classes}>
            {children}
        </div>
    )
}

type BaseCardTitleProps = {
    title: string
    className?: string
    tag?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6'
}

export function BaseCardTitle({ title, className, tag = 'h2' }: BaseCardTitleProps) {
    const classes = twMerge('leading-none pb-0 mb-0', className ?? '')
    return (
        <BaseHeadline
            headline={title}
            tag={tag}
            headlineClassProps={classes}
            classProps="my-0"
        />
    )
}

type GeneralCardType = ContainerCompType & {
    title: string
    tag?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6'
    titleClassName?: string
    button?: React.ReactNode
    baseContainerClass?: string
    baseContentClass?: string
    baseHeaderClass?: string
}
export function BaseGeneralCard(props: GeneralCardType) {
    const containerClasses = twMerge('w-full', props.baseContainerClass ?? '')
    return (
        <BaseCardContainer className={containerClasses}>
            <BaseCardHeader className={props.baseHeaderClass}>
                <BaseCardTitle title={props.title} tag={props.tag} className={props.titleClassName} />
                {props.button}
            </BaseCardHeader>
            <BaseCardContent className={props.baseContentClass}>
                {props.children}
            </BaseCardContent>
        </BaseCardContainer>
    )
}